import autocomplete from 'autocompleter';
import $ from 'jquery';

/**
 * Autocomplete: View Externer Support
 * @param elementID
 * @param helperFile
 * @param buchungsdatum
 */
window.autocompleteEinkaufProdukt = function(elementID, helperFile, buchungsdatum = '') {
  // input
  const input = document.getElementById(elementID);
  input.setAttribute('autocomplete', 'off');

  if ($(input).hasClass('readonly')) {
    return;
  }

  const row = $(input).closest('div.row');

  autocomplete({
    emptyMsg: LANG_STRINGS.noResults,
    minLength: 0,
    input: input,
    className: 'autocomplete-additional',
    fetch: function(text, update) {
      text = text.toLowerCase();

      // Ajax-Call
      $.ajax({
        url: BASE_PATH + 'ajax/autocomplete/' + helperFile,
        type: 'post',
        data: {
          type: elementID,
          search: text,
          buchungsdatum: buchungsdatum,
        },
        dataType: 'json',
        success: function(data) {
          let suggestions = Array();
          $.each(data, function(i, obj) {
            let valueData = Array();
            for (let key in obj) {
              valueData[key] = obj[key];
            }

            suggestions.push({
              'label': valueData['name'],
              'value': valueData,
            });
          });

          const itemCount = suggestions.length;

          if (itemCount === 0) {
            suggestions.push({
              'label': '',
              'value': '',
            });
            update(suggestions);
          }

          update(suggestions);

          // render mittelanfrage
          renderMittelanfrageEinkauf('.autocomplete-additional');
        }
      });
    },
    render: function(item) {
      let div = document.createElement('div');
      $(div).addClass(item.value.zulassungsstatus_id_css);
      div.textContent = item.label;
      return div;
    },
    onSelect: function(item) {
      let label = item.label;
      let tempLabel = label.replace(/\<strong\>/gi, '');
      const temp = tempLabel.replace(/\<\/strong\>/gi, '');

      const valueData = item.value;
      const url = valueData['psm_url'];

      input.label = temp;
      input.value = temp;

      row.attr('data-psm-id', valueData.uid);
      row.find('.psm_uid').val(valueData.uid);
      row.find('.psm_parent_uid').val(valueData.parent_uid);
      row.find('.psm_archived').val(valueData.archived);
      row.find('.data_key').val(valueData.dataKey);

      // make mittel and wirkstoff readonly
      $(input).attr('readonly', 'readonly').addClass('readonly');
      $(input).attr('data-url', url);

      // Einheiten
      getEinheiten(row);

      // Mehrwertsteuer
      getMwst(row);

      // Felder frei setzen
      row.find('.gebinde-inhalt').removeAttr('readonly').removeClass('readonly');
      row.find('.gesamt-menge').removeAttr('readonly').removeClass('readonly');
      row.find('.einzelpreis').removeAttr('readonly').removeClass('readonly');
      row.find('.bemerkung').removeAttr('readonly').removeClass('readonly');
      row.find('select.einzelpreis-pro').html('<option value="">---</option>');

      // Lagergruppen
      if (row.find('select.lagergruppen').length > 0) {
        getLagergruppen(row);
      } else {
        row.find('.gebinde-inhalt').focus();
      }
    },
  });
};

/**
 * autocompleteWiederverkaeufer
 * @param elementID
 * @param helperFile
 * @param additionalElement
 * @param fillHiddenField
 */
window.autocompleteWiederverkaeufer = function(elementID, helperFile, additionalElement = '', fillHiddenField = false) {
  // input
  const input = document.getElementById(elementID);
  input.setAttribute('autocomplete', 'off');

  // chips
  const chipWrap = $(input).closest('.form-field--chip-wrap').find('.chips');

  autocomplete({
    emptyMsg: LANG_STRINGS.noResults,
    minLength: 1,
    input: input,
    preventSubmit: true,
    showOnFocus: true,
    fetch: function(text, update) {
      text = text.toLowerCase();

      // chips
      let chipList = [];
      const chipElements = chipWrap.find('.chip');
      if (chipElements.length > 0) {
        chipElements.each(function() {
          chipList.push($(this).find('input[type="hidden"]').val());
        });
      }

      let additionalData = [];
      if (additionalElement !== '') {
        const additionalElementData = $(input).closest('form').find(additionalElement);
        if (additionalElementData.length > 0) {
          additionalData.push(additionalElementData.val());
        }
      }

      // Ajax-Call
      $.ajax({
        url: BASE_PATH + 'ajax/autocomplete/' + helperFile,
        type: 'post',
        data: {
          type: elementID,
          search: text,
          chips: chipList,
          additionalData: additionalData,
        },
        dataType: 'json',
        success: function(suggestions) {
          update(suggestions);
        },
      });
    },
    onSelect: function(item) {
      if (chipWrap.length > 0) {
        chipWrap.append('<span class="chip"><span>' + item.label + '</span><i class="material-icons" onclick="removeChip(this);">cancel</i><input type="hidden" name="view[' + elementID + '][]" value="' + item.value + '"></span>');
        input.value = '';
        input.blur();
      } else {
        if (fillHiddenField === true) {
          $(input).next('input[type=hidden]').val(item.value);
          input.value = item.label;
        } else {
          input.value = item.value;
          input.label = item.value;
        }

        const removeWiederverkaeuferElement = $('#remove-wiederverkaeufer-element');
        if (removeWiederverkaeuferElement.length > 0) {
          removeWiederverkaeuferElement.removeClass('display-none');
        }
      }
    },
  });
};

/**
 * removeWiederverkaeuferElementValue
 * @param element
 */
window.removeWiederverkaeuferElementValue = function(element) {
  const wiederverkaeuferID = $('#wiederverkaeufer_id');

  wiederverkaeuferID.val('');
  wiederverkaeuferID.next().val('');
  $(element).addClass('display-none');
};

/**
 * Einheiten
 * @param row
 */
window.getEinheiten = function(row) {
  const psmID = row.find('input.psm_uid').val();
  const dataKey = row.find('input.data_key').val();

  if (psmID && dataKey) {
    $.ajax({
      url: BASE_PATH + 'ajax/helper/lager/ajax.getLagerEinheiten',
      data: {
        psmID: psmID,
        dataKey: dataKey,
      },
      type: 'GET',
      success: function(html) {
        row.find('select.gebinde-einheit').html(html);
        row.find('select.gesamt-einheit').html(html);

        // Tooltip wenn falsche Einheit
        const tooltipTxt = LANG_STRINGS.lagerProduktEinheitGespeichert;
        if (row.find('select.gebinde-einheit').find('option').filter('[data-show-star]').length > 0) {
          const einheit = row.find('select.gebinde-einheit').find('option').filter('[data-show-star]').first().data('show-star');
          row.find('select.gebinde-einheit').addClass('tooltip-bottom').attr('data-title', tooltipTxt.replace('%einheit%', einheit));
          row.find('select.gesamt-einheit').addClass('tooltip-bottom').attr('data-title', tooltipTxt.replace('%einheit%', einheit));
        } else if (row.find('select.gesamt-einheit').find('option').filter('[data-show-star]').length > 0) {
          const einheit = row.find('select.gesamt-einheit').find('option').filter('[data-show-star]').first().data('show-star');
          row.find('select.gesamt-einheit').addClass('tooltip-bottom').attr('data-title', tooltipTxt.replace('%einheit%', einheit));
        } else {
          row.find('select.gebinde-einheit, select.gesamt-einheit').removeClass(tooltip - bottom).removeAttr('title');
        }

        initTooltip();
      },
    });
  }
};

/**
 * Mehrwertsteuer
 * @param row
 */
window.getMwst = function(row) {
  $.ajax({
    url: BASE_PATH + 'ajax/helper/lager/ajax.getLagerMwst',
    success: function(html) {
      row.find('select.warenwert-mwst').html(html).removeAttr('disabled').removeAttr('readonly').removeClass('readonly');
    },
  });
};

/**
 * Lagergruppen
 * @param row
 */
window.getLagergruppen = function(row) {
  $.ajax({
    url: BASE_PATH + 'ajax/helper/lager/ajax.getLagergruppen',
    success: function(html) {
      row.find('select.lagergruppen').html(html).removeAttr('disabled').removeAttr('readonly').removeClass('readonly').change().focus();
    },
  });
};

/**
 * calcEinkauf
 * @param editfield
 */
window.calcEinkauf = function(editfield) {
  const row = $(editfield).closest('div.row');

  const gebindeInhaltElement = row.find('input.gebinde-inhalt');
  const gebindeEinheitElement = row.find('select.gebinde-einheit');
  const gebindeAnzahlElement = row.find('input.gebinde-anzahl');

  const gesamtMengeElement = row.find('input.gesamt-menge');
  const gesamtEinheitElement = row.find('select.gesamt-einheit');

  const einzelPreisElement = row.find('input.einzelpreis');
  const einzelpreisProElement = row.find('select.einzelpreis-pro');

  const rabatt1ProzentElement = row.find('input.rabatt1-prozent');
  const rabatt1WertElement = row.find('input.rabatt1-wert');

  const warenWertElement = row.find('input.warenwert');
  const warenWertMwstElement = row.find('select.warenwert-mwst');
  const warenWertGesamtElement = row.find('input.warenwert-gesamt');

  // Berechnungen

  // Gesamt-Menge
  if (gebindeInhaltElement.val() > 0) {
    const gebindeGesamt = gebindeInhaltElement.val() * gebindeAnzahlElement.val();

    gesamtMengeElement.val(numberFormat(gebindeGesamt, 2));
    gebindeInhaltElement.val(numberFormat(gebindeInhaltElement.val(), 2));
  }

  // Einzelpreis
  if (einzelPreisElement.val() > 0) {
    einzelPreisElement.val(numberFormat(einzelPreisElement.val(), 2));

    if (rabatt1ProzentElement.val() === '' && rabatt1WertElement.val() === '') {
      rabatt1ProzentElement.removeAttr('disabled').removeAttr('readonly').removeClass('readonly');
      rabatt1WertElement.removeAttr('disabled').removeAttr('readonly').removeClass('readonly');
    } else if (rabatt1ProzentElement.val() > 0) {
      rabatt1ProzentElement.removeAttr('disabled').removeAttr('readonly').removeClass('readonly');
    } else if (rabatt1WertElement.val() > 0) {
      rabatt1WertElement.removeAttr('disabled').removeAttr('readonly').removeClass('readonly');
    }
  } else {
    rabatt1ProzentElement.attr('readonly', 'readonly').addClass('readonly').val('');
    rabatt1WertElement.attr('readonly', 'readonly').addClass('readonly').val('');
  }

  // Rabatt 1
  let gesamtMengeCalc = parseFloat(gesamtMengeElement.val());
  const einzelpreisCalc = parseFloat(einzelPreisElement.val());
  let rabatt1ProzentCalc = parseFloat(rabatt1ProzentElement.val());
  let rabatt1WertCalc = parseFloat(rabatt1WertElement.val());

  gesamtMengeCalc = (typeof einzelpreisProElement.find('option:selected').data('is-stueck') !== 'undefined' ? parseInt(gebindeAnzahlElement.val()) : gesamtMengeCalc);

  if (rabatt1ProzentElement.val() > 0) {
    rabatt1ProzentCalc = rabatt1ProzentElement.val();
    rabatt1ProzentElement.val(numberFormat(rabatt1ProzentCalc, 2));

    rabatt1WertCalc = ((gesamtMengeCalc * einzelpreisCalc) - (gesamtMengeCalc * einzelpreisCalc * (rabatt1ProzentCalc / 100)));

    rabatt1WertElement.attr('readonly', 'readonly').addClass('readonly');
    rabatt1WertElement.val(numberFormat(rabatt1WertCalc, 2));
  } else if (rabatt1WertElement.val() > 0) {
    rabatt1WertCalc = rabatt1WertElement.val();
    rabatt1WertElement.val(numberFormat(rabatt1WertCalc, 2));
    rabatt1ProzentElement.attr('readonly', 'readonly').addClass('readonly');

    rabatt1ProzentElement.val('');
  }

  // Warenwert
  let warenwertTmpCalc = (gesamtMengeCalc * einzelpreisCalc);
  if (rabatt1WertElement.val() > 0) {
    warenwertTmpCalc = parseFloat(rabatt1WertElement.val());
  }
  warenWertElement.val(numberFormat(warenwertTmpCalc, 2));

  // Warenwert gesamt
  const warenwertMwstCalc = parseFloat(warenWertMwstElement.find('option:selected').attr('data-wert'));

  const warenwertGesamtCalc = warenwertTmpCalc + (warenwertTmpCalc * (warenwertMwstCalc / 100));
  warenWertGesamtElement.val(numberFormat(warenwertGesamtCalc, 2));

  // Regeln Focus und Disable Felder

  // Focus zum nächsten passenden Feld erzwingen
  if ($(editfield).is(gebindeInhaltElement)) {
    if (Number(gebindeInhaltElement.val()) > 0) {
      gebindeEinheitElement.removeAttr('disabled').removeAttr('readonly').removeClass('readonly');
      gebindeAnzahlElement.removeAttr('readonly').removeClass('readonly');

      // Wenn Gebinde gesetzt, dann Gesamt readonly/disabled
      gesamtMengeElement.addClass('readonly').attr('readonly', 'readonly');
      gesamtEinheitElement.addClass('readonly').attr('disabled', 'disabled');

      gebindeEinheitElement.focus();
    } else {
      gebindeEinheitElement.addClass('readonly').attr('disabled', 'disabled').val('');
      gebindeAnzahlElement.addClass('readonly').attr('readonly', 'readonly').val('');

      gesamtMengeElement.removeAttr('readonly').removeClass('readonly').val('');
      gesamtEinheitElement.addClass('readonly').attr('disabled', 'disabled').val('');

      gesamtMengeElement.focus();
    }
  }

  if ($(editfield).is(gebindeAnzahlElement)) {
    einzelPreisElement.focus();
  }

  if ($(editfield).is(gesamtMengeElement)) {
    if (Number(gesamtMengeElement.val()) > 0) {
      gesamtMengeElement.val(numberFormat(gesamtMengeElement.val(), 2));

      gebindeInhaltElement.addClass('readonly').attr('readonly', 'readonly').val('');
      gesamtEinheitElement.removeClass('readonly').removeAttr('disabled').removeAttr('readonly').val('');
    } else {
      gebindeInhaltElement.removeClass('readonly').removeAttr('disabled').removeAttr('readonly').val('');
      gesamtEinheitElement.addClass('readonly').attr('disabled', 'disabled').val('');
    }

    gesamtEinheitElement.focus();
  }

  // Einheit für gesamtEinheitElement übernehmen
  if ($(editfield).is(gebindeEinheitElement)) {
    const selectedBeforeIsStueck = (typeof einzelpreisProElement.find('option:selected').data('is-stueck') !== 'undefined');
    einzelpreisProElement.html('');

    if (gebindeEinheitElement.val() > 0) {
      // Gebinde-Einheit für Gessamt-Einheit übernehmen
      const selected = $(gebindeEinheitElement).find('option:selected').attr('data-id');
      gesamtEinheitElement.find('option[data-id=' + selected + ']').prop('selected', 'selected');

      // Gewählte Einheit
      let einheitHtml = $.trim(gebindeEinheitElement.find('option:selected').html());
      einheitHtml = einheitHtml.replace(/\*/g, '');
      einzelpreisProElement.append('<option value="' + gebindeEinheitElement.find('option:selected').val() + '">' + einheitHtml + '</option>');

      // Stück
      einzelpreisProElement.append('<option value="242" data-is-stueck="1"' + (selectedBeforeIsStueck ? ' selected' : '') + '>' + LANG_STRINGS.stueck + '</option>');
      einzelpreisProElement.removeAttr('disabled').removeAttr('readonly').removeClass('readonly');
    } else {
      gesamtEinheitElement.find('option[data-id=0]').prop('selected', 'selected');
    }

    gebindeAnzahlElement.focus();
  }

  if ($(editfield).is(gesamtEinheitElement)) {
    einzelPreisElement.focus();

  }
  if ($(editfield).is(einzelPreisElement)) {
    einzelpreisProElement.focus();
  }
  if ($(editfield).is(einzelpreisProElement)) {
    if (!rabatt1ProzentElement.hasClass('readonly')) {
      rabatt1ProzentElement.focus();
    } else if (!rabatt1WertElement.hasClass('readonly')) {
      rabatt1WertElement.focus();
    }
  }
  if ($(editfield).is(rabatt1ProzentElement)) {
    if (rabatt1ProzentElement.val() > 0) {
    } else {
      rabatt1ProzentElement.val('');
      rabatt1ProzentElement.removeAttr('disabled').removeAttr('readonly').removeClass('readonly');
      rabatt1WertElement.val('');
    }
  }
  if ($(editfield).is(rabatt1WertElement)) {
    if (rabatt1WertElement.val() > 0) {
      warenWertMwstElement.focus();
    }
  }
};

/**
 * Reset Mittel
 * @param element
 */
window.resetMittel = function(element) {
  const row = $(element).closest('div.modal-content').find('div.modal-body div.row');

  // Produkt leeren
  row.find('.smittel').each(function() {
    const input = $(this);
    input.removeAttr('readonly');
    input.removeClass('readonly');
    input.removeAttr('data-url');
    input.val('');
  });

  // Alle anderen Inputs leeren
  const inputsToClear = row.find('input:not(.smittel)');
  inputsToClear.each(function() {
    const input = $(this);
    input.val('');
    input.addClass('readonly').attr('readonly', 'readonly');
  });

  // Selects leeren
  row.find('select').each(function() {
    const select = $(this);
    select.find('option').remove();
    select.val('');
    select.addClass('readonly').attr('disabled', 'disabled');
  });

  row.attr('data-psm-id', '');
  row.attr('data-key', '');
  row.find('.smittel').click();
  row.find('.smittel').focus();
};

/**
 * Build Einkauf Row
 * @param json
 * @param table
 */
window.buildEinkaufRow = function(json, table) {
  // Template
  let template = $('#einkauf-row').html();

  const jsonObject = JSON.parse(json);
  $.each(jsonObject, function(k, v) {
    template = template.replace(new RegExp(k, 'g'), v);
  });

  if ($(table).find('*[data-row-key="' + jsonObject.__KEY__ + '"]').length > 0) {
    $(table).find('*[data-row-key="' + jsonObject.__KEY__ + '"]').replaceWith(template);
  } else {
    $(table).append(template);
  }
};

/**
 * renderMittelanfrageEinkauf
 * @param element
 */
window.renderMittelanfrageEinkauf = function(element) {
  $(element).append('<div class="mittelanfrage" onclick="openMittelanfrageEinkauf(); return false;">' + LANG_STRINGS.mittelanfrage + '</div>');
};

/**
 * openMittelanfrageEinkauf
 */
window.openMittelanfrageEinkauf = function() {
  const autocompleteName = (document.getElementById('mittel-psmID')).getAttribute('aria-controls');
  document.getElementById(autocompleteName).remove();
  ajaxDialog(BASE_PATH + 'ajax/dialog/lager/ajax.mittelanfrage');
};